import { useMemo, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import SEARCH_QUERY from '../queries/SEARCH_QUERY';
import parseSearchQueryData from '../dataParsing/searchQueryDataParser';

const useSearchIds = ( type, courseIds ) => {   
      
    const [ fetchSearch, { data, loading, error } ] = useLazyQuery( SEARCH_QUERY, {
        variables: {
            types: [ type ],
            query: '',
            page: 1,
            limit: 10000,
            sort: 'name',
            order: 'asc',
            localeCode: 'en_US',
            _ids: courseIds,
        }, 
        fetchPolicy: 'network-only' 
    } );

    useEffect( () => {
        if ( courseIds && courseIds.length > 0 ) {
            fetchSearch();
        }
    }, [ courseIds ] );

    const items = useMemo( () => {
        if ( data?.search?.edges ) {
            return parseSearchQueryData( { type, data } );
        } 

        return;
    }, [ data ] );
 
    return useMemo( () => {
        return {
            items,
            searchIdError: error,
            searchIdLoading: loading
        };
    }, [ items, error, loading ] );
};

export default useSearchIds;
